// import { useState } from "react";
// import { CheckCircleIcon } from "@heroicons/react/24/outline";
// import { useGetAssignmentsQuery } from "../../api/CourseService";
// import {
//   format,
//   endOfDay,
//   isBefore,
//   isToday,
//   differenceInHours,
//   differenceInCalendarDays,
// } from "date-fns";

// export default function Assignments() {
//   const [page, setPage] = useState(1);
//   const [searchString, setSearchString] = useState("");

//   const { data, loading, fetchMore, refetch } = useGetAssignmentsQuery({
//     variables: {
//       pagination: { limit: 20, page },
//       searchString,
//     },
//     errorPolicy: "all",
//     fetchPolicy: "cache-and-network",
//   });

//   const assignments = data?.getAssignments?.docs || [];
//   const hasNextPage = data?.getAssignments?.hasNextPage;

//   const isCourseFinished = (assignment: any, courseId: any) =>
//     assignment?.coursesProgress?.some(
//       (cp: any) => cp?.courseId === courseId && cp?.finished
//     );

//   const isLabFinished = (assignment: any, labId: any) =>
//     assignment?.labsProgress?.some(
//       (lp: any) => lp?.labId === labId && lp?.finished
//     );

//   const getStatusLabel = (assignment: any) => {
//     const progress = assignment?.stats?.progress ?? 0;
//     const rawEndDate = new Date(Number(assignment?.endDate));
//     const endDate = endOfDay(rawEndDate);
//     const now = new Date();

//     if (progress === 100) return "Finished ✅";
//     if (isBefore(endDate, now)) return "Has ended";

//     if (isToday(endDate)) {
//       const hoursLeft = Math.max(differenceInHours(endDate, now), 1);
//       return `Ends in ${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""}`;
//     }

//     const days = differenceInCalendarDays(endDate, now);
//     return `Ends in ${days} day${days !== 1 ? "s" : ""}`;
//   };

//   const hasAssignmentEnded = (assignment: any) => {
//     const rawEndDate = new Date(Number(assignment?.endDate));
//     const endDate = endOfDay(rawEndDate);
//     return isBefore(endDate, new Date());
//   };

//   const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchString(e.target.value);
//     setPage(1); // Reset to first page
//     refetch({ pagination: { limit: 6, page: 1 }, searchString: e.target.value });
//   };

//   const loadMore = () => {
//     setPage((prev) => prev + 1);
//     fetchMore({
//       variables: {
//         pagination: { limit: 6, page: page + 1 },
//         searchString,
//       },
//     });
//   };

//   return (
//     <div className="p-4 space-y-6">
//       {/* Search bar */}
//       <div>
//         <input
//           type="text"
//           className="input input-bordered w-full md:max-w-md"
//           placeholder="Search assignments..."
//           value={searchString}
//           onChange={handleSearchChange}
//         />
//       </div>

//       {/* Assignments grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
//         {assignments.map((assignment) => (
//           <div
//             key={assignment?._id}
//             className={`card bg-base-100 shadow-xl border border-white/10 ${
//               hasAssignmentEnded(assignment)
//                 ? "opacity-50 grayscale pointer-events-none"
//                 : ""
//             }`}
//           >
//             <div className="card-body flex flex-col">
//               <h2 className="card-title">{assignment?.title}</h2>

//               <div className="text-sm text-gray-500 mb-2 flex justify-between">
//                 <span>
//                   {format(new Date(Number(assignment?.startDate)), "PP")} →{" "}
//                   {format(new Date(Number(assignment?.endDate)), "PP")}
//                 </span>
//                 <span className="text-xs text-primary">
//                   {getStatusLabel(assignment)}
//                 </span>
//               </div>

//               <div>
//                 <p className="font-medium mb-1">Courses:</p>
//                 <ul className="space-y-1">
//                   {assignment?.joinedCourses?.map((course) => {
//                     const finished = isCourseFinished(assignment, course?._id);
//                     return (
//                       <li
//                         key={course?._id}
//                         className="flex items-center space-x-2 text-sm"
//                       >
//                         <div className="avatar">
//                           <div className="w-10 rounded-full">
//                             <img
//                               src={`https://static.socora.com/img/course/small/${course?._id}.jpg`}
//                               alt={course?.name}
//                             />
//                           </div>
//                         </div>
//                         <a
//                           href={`/courses/${course?._id}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className={`link ${
//                             finished ? "text-green-500 font-medium" : ""
//                           }`}
//                         >
//                           {course?.name}
//                         </a>
//                         {finished && (
//                           <CheckCircleIcon className="w-4 h-4 text-green-500" />
//                         )}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>

//               <div className="mt-3">
//                 <p className="font-medium mb-1">Labs:</p>
//                 <ul className="space-y-1">
//                   {assignment?.joinedLabs?.map((lab) => {
//                     const finished = isLabFinished(assignment, lab?._id);
//                     return (
//                       <li
//                         key={lab?._id}
//                         className="flex items-center space-x-2 text-sm"
//                       >
//                         <div className="avatar">
//                           <div className="w-10 rounded-full">
//                             <img
//                               src={`https://static.socora.com/img/lab/small/${lab?._id}.jpg`}
//                               alt={lab?.name}
//                             />
//                           </div>
//                         </div>
//                         <a
//                           href={`/labs/${lab?._id}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className={`link ${
//                             finished ? "text-green-500 font-medium" : ""
//                           }`}
//                         >
//                           {lab?.name}
//                         </a>
//                         {finished && (
//                           <CheckCircleIcon className="w-4 h-4 text-green-500" />
//                         )}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>

//               <div className="mt-auto pt-4">
//                 <div className="flex justify-between text-sm mb-1">
//                   <span>Progress</span>
//                   <span>{assignment?.stats?.progress}%</span>
//                 </div>
//                 <progress
//                   className="progress progress-primary w-full"
//                   value={assignment?.stats?.progress}
//                   max="100"
//                 />
//               </div>

//               <div className="mt-4 text-sm text-gray-600">
//                 <div>
//                   Finished: {assignment?.stats?.finishedCount} /{" "}
//                   {assignment?.stats?.totalCount}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Load More */}
//       {hasNextPage && (
//         <div className="flex justify-center pt-6">
//           <button
//             onClick={loadMore}
//             className="btn btn-primary btn-outline"
//             disabled={loading}
//           >
//             {loading ? "Loading..." : "Load More"}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

import { useState } from "react";
import {
  Assignment,
  useGetAssignmentsQuery,
  useGetFinishedAssignmentsQuery,
} from "../../api/CourseService";
import {
  format,
  endOfDay,
  isBefore,
  isToday,
  differenceInHours,
  differenceInCalendarDays,
  isAfter,
} from "date-fns";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import PaginationButtons from "../../components/PaginationButtons";
import moment from "moment";

export function getRemainingDays(endDate: any) {
  const today = moment().startOf("day");
  const end = moment(endDate).startOf("day");
  const diff = end.diff(today, "days");
  return Math.max(diff, 0); // Ensure no negative numbers
}

export function timeProgress(startDate: string, endDate: string) {
  const start = moment(parseInt(startDate));
  const end = moment(parseInt(endDate));
  const remaningDays = getRemainingDays(end);
  const hasStarted = start.isBefore(moment());
  const hasEnded = remaningDays === 0;

  if (hasEnded)
    return {
      status: "ENDED",
      label: "Assignment has ended",
    };
  if (!hasStarted)
    return {
      status: "NOT_STARTED",
      label: `Starts in ${getRemainingDays(start)} days`,
    };

  return {
    status: "IN_PROGRESS",
    label: `Ends in ${getRemainingDays(end)} days`,
  };
}

function AssignmentCard({ assignment }: { assignment: any }) {
  const isCourseFinished = (assignment: any, courseId: any) =>
    assignment?.coursesProgress?.some(
      (cp: any) => cp?.courseId === courseId && cp?.finished
    );

  const isLabFinished = (assignment: any, labId: any) =>
    assignment?.labsProgress?.some(
      (lp: any) => lp?.labId === labId && lp?.finished
    );

  const hasAssignmentEnded = () => {
    const rawEndDate = new Date(Number(assignment?.endDate));
    const endDate = endOfDay(rawEndDate);
    return isBefore(endDate, new Date());
  };

  const getStatusLabel = () => {
    return timeProgress(assignment?.startDate, assignment?.endDate).label;
  };

  return (
    <div className={`card  `}>
      <div className="card-body flex flex-col">
        <h2 className="card-title">{assignment?.title}</h2>
        <div className="text-sm text-gray-500 mb-2 flex justify-between">
          <span>
            {format(new Date(Number(assignment?.startDate)), "PP")} →{" "}
            {format(new Date(Number(assignment?.endDate)), "PP")}
          </span>

          <span>
            {assignment.status === "ended" ? (
              assignment?.stats?.finishedCount ===
              assignment?.stats?.totalCount ? (
                <span className="text-green-400">
                  You have finished the assignment successfully
                </span>
              ) : (
                <span className="text-red-400">
                  You have failed to finish this assignment
                </span>
              )
            ) : (
              <span className="text-xs text-primary">{getStatusLabel()}</span>
            )}
          </span>
        </div>

        <div>
          <p className="font-medium mb-1">Courses:</p>
          <ul className="space-y-1">
            {assignment?.joinedCourses?.map((course: any) => {
              const finished = isCourseFinished(assignment, course?._id);
              return (
                <li
                  key={course?._id}
                  className="flex items-center space-x-2 text-sm"
                >
                  <div className="avatar">
                    <div className="w-10 rounded-full">
                      <img
                        src={`https://static.socora.com/img/course/small/${course?._id}.jpg`}
                        alt={course?.name}
                      />
                    </div>
                  </div>
                  <a
                    href={`/courses/${course?._id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`link ${
                      finished ? "text-green-500 font-medium" : ""
                    }`}
                  >
                    {course?.name}
                  </a>
                  {finished && (
                    <CheckCircleIcon className="w-4 h-4 text-green-500" />
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="mt-3">
          <p className="font-medium mb-1">Labs:</p>
          <ul className="space-y-1">
            {assignment?.joinedLabs?.map((lab: any) => {
              const finished = isLabFinished(assignment, lab?._id);
              return (
                <li
                  key={lab?._id}
                  className="flex items-center space-x-2 text-sm"
                >
                  <div className="avatar">
                    <div className="w-10 rounded-full">
                      <img
                        src={`https://static.socora.com/img/lab/small/${lab?._id}.jpg`}
                        alt={lab?.name}
                      />
                    </div>
                  </div>
                  <a
                    href={`/labs/${lab?._id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`link ${
                      finished ? "text-green-500 font-medium" : ""
                    }`}
                  >
                    {lab?.name}
                  </a>
                  {finished && (
                    <CheckCircleIcon className="w-4 h-4 text-green-500" />
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="mt-auto pt-4">
          <div className="flex justify-between text-sm mb-1">
            <span>Progress</span>
            <span>{assignment?.stats?.progress}%</span>
          </div>
          <progress
            className="progress progress-primary w-full"
            value={assignment?.stats?.progress}
            max="100"
          />
        </div>

        <div className="mt-4 text-sm text-gray-600">
          <div>
            Finished: {assignment?.stats?.finishedCount} /{" "}
            {assignment?.stats?.totalCount}
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  assignments: any;
  loading: boolean;
  onSelect: (assignment: Assignment | null) => void;
}

export function AssignmentsTable({ assignments, loading, onSelect }: Props) {
  const getStatusLabel = (assignment: Assignment) => {
    return timeProgress(
      assignment?.startDate as any,
      assignment?.endDate as any
    ).label;
  };

  return (
    <div className="overflow-x-auto">
      <table className="table w-full bg-base-200">
        <thead>
          <tr>
            <th>Title</th>
            <th>Dates</th>
            <th>Status</th>
            <th>Courses</th>
            <th>Labs</th>
            <th>Progress</th>
            <th>Finished</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((a: any) => (
            <tr
              key={a._id}
              className="cursor-pointer hover:bg-base-200"
              onClick={() => onSelect(a)}
            >
              <td>{a.title}</td>
              <td>
                {format(new Date(Number(a.startDate)), "PP")} –{" "}
                {format(new Date(Number(a.endDate)), "PP")}
              </td>
              <td className="text-sm text-gray-500">{getStatusLabel(a)}</td>
              <td>{a?.joinedCourses?.length || 0}</td>
              <td>{a?.joinedLabs?.length || 0}</td>
              <td className="w-32">
                <progress
                  className="progress progress-primary w-full"
                  value={a?.stats?.progress}
                  max="100"
                />
              </td>
              <td>
                {a?.stats?.finishedCount ?? 0} / {a?.stats?.totalCount ?? 0}
              </td>
            </tr>
          ))}
          {assignments.length === 0 && !loading && (
            <tr>
              <td colSpan={7} className="text-center text-gray-500">
                No assignments found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function InProgressAssignments() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [selectedAssignment, setSelectedAssignment] = useState<any>(null);

  const { data, loading, refetch } = useGetAssignmentsQuery({
    variables: { pagination: { limit: pageSize, page }, searchString },
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  const assignments = data?.getAssignments?.docs || [];
  const totalDocs = data?.getAssignments?.totalDocs ?? 0;
  const pageCount = Math.ceil(totalDocs / pageSize);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchString(value);
    setPage(1);
    refetch({ pagination: { limit: pageSize, page: 1 }, searchString: value });
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    refetch({ pagination: { limit: pageSize, page: newPage }, searchString });
  };

  return (
    <div className="">
      {/* Optional search bar */}
      {/* <input
        type="text"
        className="input input-bordered w-full md:max-w-md mb-4"
        placeholder="Search assignments..."
        value={searchString}
        onChange={handleSearchChange}
      /> */}

      <AssignmentsTable
        assignments={assignments}
        loading={loading}
        onSelect={setSelectedAssignment}
      />

      <PaginationButtons
        page={page}
        setPage={handlePageChange}
        pageCount={pageCount}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />

      {selectedAssignment && (
        <dialog
          id="assignment_modal"
          className="modal modal-open"
          onClose={() => setSelectedAssignment(null)}
        >
          <div className="modal-box max-w-4xl w-full">
            <button
              className="btn btn-sm btn-circle absolute right-2 top-2 z-20"
              onClick={() => setSelectedAssignment(null)}
            >
              ✕
            </button>
            <AssignmentCard assignment={selectedAssignment} />
          </div>
        </dialog>
      )}
    </div>
  );
}

export function EndedAssignmentsTable({
  assignments,
  loading,
  onSelect,
}: Props) {
  const getStatusLabel = (assignment: Assignment) => {
    return timeProgress(
      assignment?.startDate as any,
      assignment?.endDate as any
    ).label;
  };

  return (
    <div className="overflow-x-auto">
      <table className="table w-full bg-base-200">
        <thead>
          <tr>
            <th>Title</th>
            <th>Dates</th>
            <th>Status</th>
            <th>Courses</th>
            <th>Labs</th>
            <th>Progress</th>
            <th>Finished</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((a: any) => (
            <tr
              key={a._id}
              className={`cursor-pointer hover:bg-base-200 `}
              onClick={() => onSelect(a)}
            >
              <td>{a.title}</td>
              <td>
                {format(new Date(Number(a.startDate)), "PP")} –{" "}
                {format(new Date(Number(a.endDate)), "PP")}
              </td>
              <td className="text-sm text-gray-500">
                {a?.stats?.finishedCount === a?.stats?.totalCount ? (
                  <span className="text-green-400">
                    You have finished the assignment successfully
                  </span>
                ) : (
                  <span className="text-red-400">
                    You have failed to finish this assignment
                  </span>
                )}
              </td>
              <td>{a?.joinedCourses?.length || 0}</td>
              <td>{a?.joinedLabs?.length || 0}</td>
              <td className="w-32">
                <progress
                  className="progress progress-primary w-full"
                  value={a?.stats?.progress}
                  max="100"
                />
              </td>
              <td>
                {a?.stats?.finishedCount ?? 0} / {a?.stats?.totalCount ?? 0}
              </td>
            </tr>
          ))}
          {assignments.length === 0 && !loading && (
            <tr>
              <td colSpan={7} className="text-center text-gray-500">
                No assignments found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function FinishedAssignments() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [selectedAssignment, setSelectedAssignment] = useState<any>(null);

  const { data, loading, refetch } = useGetFinishedAssignmentsQuery({
    variables: { pagination: { limit: pageSize, page }, searchString },
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  const assignments = data?.getFinishedAssignments?.docs || [];
  const totalDocs = data?.getFinishedAssignments?.totalDocs ?? 0;
  const pageCount = Math.ceil(totalDocs / pageSize);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchString(value);
    setPage(1);
    refetch({ pagination: { limit: pageSize, page: 1 }, searchString: value });
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    refetch({ pagination: { limit: pageSize, page: newPage }, searchString });
  };

  return (
    <div className="">
      {/* Optional search bar */}
      {/* <input
        type="text"
        className="input input-bordered w-full md:max-w-md mb-4"
        placeholder="Search assignments..."
        value={searchString}
        onChange={handleSearchChange}
      /> */}

      <EndedAssignmentsTable
        assignments={assignments}
        loading={loading}
        onSelect={setSelectedAssignment}
      />

      <PaginationButtons
        page={page}
        setPage={handlePageChange}
        pageCount={pageCount}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />

      {selectedAssignment && (
        <dialog
          id="assignment_modal"
          className="modal modal-open"
          onClose={() => setSelectedAssignment(null)}
        >
          <div className="modal-box max-w-4xl w-full">
            <button
              className="btn btn-sm btn-circle absolute right-2 top-2 z-20"
              onClick={() => setSelectedAssignment(null)}
            >
              ✕
            </button>
            <AssignmentCard assignment={selectedAssignment} />
          </div>
        </dialog>
      )}
    </div>
  );
}

export default function Assignments() {
  return (
    <div className="flex flex-col gap-6">
      <div className="p-4">
        <div className="text-2xl font-bold mb-4 ">Current Assignments</div>
        <div>
          <InProgressAssignments></InProgressAssignments>
        </div>
      </div>
      <div className="divider"></div>
      <div className="p-4">
        <div className="text-2xl font-bold mb-4 ">Closed Assignments</div>
        <div>
          <FinishedAssignments></FinishedAssignments>
        </div>
      </div>
    </div>
  );
}
